import React, { useEffect } from "react";
import { ErrorPageLockIcon } from "../Icons/ErrorPageLockIcon";
import { ErrorPageWrapper } from "./ErrorPageWrapper";
import { useErrorIconSize } from "../Icons/ErrorIconSize";
import { usePcpLiveLessonContext } from "../../store";

/**
 * Shown when
 * the user is participating in the call and gets removed.
 *
 * _Not shown_ when the user got removed previously and tries to log in again!
 */
export const RemovedFromCallPage = (): JSX.Element => {

    const iconSize = useErrorIconSize();

    const clearTokens = usePcpLiveLessonContext(s => s.clearTokens);
    useEffect(() => clearTokens(), [clearTokens]);


    return <ErrorPageWrapper
        icon={<ErrorPageLockIcon size={iconSize}/>}
        title={'Dein Lehrer hat Dich aus dem Unterricht ausgeschlossen!'}
        content={<div>Du kannst leider erst wieder am <b>nächsten Unterrichtstermin</b> teilnehmen.</div>}
    />
};
